module.exports = __webpack_public_path__ + "static/media/BeTheHero.8dcf2456.png";